import React, { useEffect, useState } from "react";
import axios from "axios";

const ThirdCard = () => {
  const [valuesSection, setValuesSection] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/about/get-about`
        );

        if (
          res.data.success &&
          res.data.data.length > 0 &&
          res.data.data[0].valuesSection
        ) {
          setValuesSection(res.data.data[0].valuesSection);
        }
      } catch (err) {
        console.error("Failed to load values section", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center py-20 text-gray-400">
        Loading...
      </div>
    );
  }

  if (!valuesSection) return null;

  const { mainHeading, cards } = valuesSection;

  const Card = ({ title, description }) => (
    <div className="bg-white shadow-lg rounded-lg p-4 flex flex-col">
      <h2 className="text-xl font-bold text-gray-800 text-center">
        {title}
      </h2>
      <p className="mt-2 text-gray-600 text-justify">
        {description}
      </p>
    </div>
  );

  return (
    <>
      {/* Main Heading */}
      <h1 className="mt-6 text-[#212121] font-bold text-3xl w-full text-center">
        {mainHeading}
      </h1>

      {/* Cards Section */}
      <div className="my-10 bg-gradient-to-r from-[#2F9BD6] to-[#daedf7] py-10 px-4 md:px-10">
        <div className="flex flex-wrap justify-center w-full">
          {/* First row – first 3 cards */}
          {cards.slice(0, 3).map((card, index) => (
            <div
              key={index}
              className="w-full sm:w-1/2 lg:w-1/3 p-4"
            >
              <Card
                title={card.heading}
                description={card.description}
              />
            </div>
          ))}
        </div>

        <div className="flex flex-wrap justify-center w-full">
          {/* Second row – remaining cards */}
          {cards.slice(3).map((card, index) => (
            <div
              key={index}
              className="w-full sm:w-1/2 lg:w-1/2 p-4"
            >
              <Card
                title={card.heading}
                description={card.description}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ThirdCard;
